'use client';
/**
 * To get/set values from/to Browswer SessionStorage
 */
export class Storage {
  public static set<T>(key: string, payload: T): void {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(key, JSON.stringify({value: payload}));
    }
  }

  public static get<T>(key: string): T | undefined {
    if (typeof window ==='undefined' || !window?.sessionStorage){
      return undefined
    } else {
      const dataString = sessionStorage.getItem(key);
      if (dataString === null || dataString === undefined || dataString === 'undefined') {
        return undefined
      } else {
        const dataObject: {value: T} = JSON.parse(dataString)
        return dataObject?.value
      }
    }
  }
}
